function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
(function (factory) {
  "use strict";

  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['jquery'], function ($) {
      return factory($, window, document);
    });
  } else if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
    // CommonJS
    module.exports = function (root, $) {
      if (!root) {
        // CommonJS environments without a window global must pass a
        // root. This will give an error otherwise
        root = window;
      }
      if (!$) {
        $ = typeof window !== 'undefined' ?
        // jQuery's factory checks for a global window
        require('jquery') : require('jquery')(root);
      }
      return factory($, root, root.document);
    };
  } else {
    // Browser
    factory(jQuery, window, document);
  }
})(function ($, window, document, undefined) {
  // eslint-disable-line
  "use strict";

  var addEventListeners = function addEventListeners(datatable) {
    var ajaxUrl = datatable.ajax.url();
    datatable.columns().every(function () {
      var column = this;
      $('input[trk-datatables-input]', column.header()).each(function () {
        // we need to add current value to search
        column.search(this.value);
        // we need to apply search if there is value and not serverside
        if (!ajaxUrl && $(column.header()).data('datatableSearchValue')) datatable.draw();
        // add event listener for change
        $(this).on('keyup change', function () {
          // somehow column.search() is also "" when we clear input field. this
          // is noticable only for client side processing (serverside keep value)
          if (this.value == "" || column.search() != this.value) {
            if ($(column.header()).data().datatableRange && !ajaxUrl) {
              // addRangeSearch is only for client side processing
              // this.value.indexOf(' - ') != -1 # does not cover empty search
              // addRangeSearch(column, this.value)
              datatable.draw();
              console.log("input keyup change range search ".concat(this.value));
            } else {
              column.search(this.value).draw();
              console.log("input keyup change search ".concat(this.value));
            }
          }
        });
      });
      $('input[trk-datatables-checkbox]', column.header()).each(function () {
        column.search($(this).val());
        if (!ajaxUrl && typeof $(column.header()).data().datatableSearchValue !== 'undefined') {
          datatable.draw();
        }
        return $(this).on('change', function () {
          column.search($(this).val()).draw();
          return console.log("input checkbox change search " + $(this).val());
        });
      });
      $('select[trk-datatables-select]', column.header()).each(function () {
        // add current value, multi select returns array, so we join by |
        var multiple_value = ($(this).val() || []).join('|');
        column.search(multiple_value, true, false);
        // we need to apply search it there is value and not serverside
        if (!ajaxUrl && $(column.header()).data().datatableSearchValue) datatable.draw();
        $(this).on('change', function () {
          multiple_value = ($(this).val() || []).join('|');
          if (column.search() != multiple_value) {
            column.search(multiple_value, true, false).draw();
            console.log("select change search true ".concat(multiple_value));
          }
        });
      });
    });
  };
  return addEventListeners;
});